import { initializeApp } from "firebase/app";
import { Auth, getAuth } from "firebase/auth";

const config = {
  apiKey: "AIzaSyCMbd31Q1sFNUA53b2RK-RL4odWbr3W-Zc",
  authDomain: "stairsolutions-97942.firebaseapp.com",
  projectId: "stairsolutions-97942",
  storageBucket: "stairsolutions-97942.firebasestorage.app",
  messagingSenderId: "103354759199",
  appId: "1:103354759199:web:cb10de60c667fd1c943d2a",
  measurementId: "G-1KSYZCYESZ",
};

export const app = initializeApp(config);

export const auth: Auth = getAuth(app);
